import { componentCategories } from '~/components/component-library/internal/Sidebar/data'
import { ComponentCategory } from '~/components/component-library/internal/Sidebar/types'
import { buildLinearIssueUrl } from '~/utils/linear'

/** Absolute URL to a component's page in the running app. */
export const getComponentPageUrl = (id: string) =>
  window.location.origin + '/component-library/' + id + '/'

/** Prefilled Linear "new issue" URL for reporting a bug on a component. */
export const buildComponentIssueUrl = (name: string) =>
  buildLinearIssueUrl({
    title: 'CL issue: ' + name,
    assignee: 'matthew',
    priority: 0,
    status: 'Todo',
    labels: 'Component library',
  })

/**
 * Filter the registry to categories with components matching the query. Every
 * whitespace-separated keyword must appear (case-insensitive substring) in a
 * component's name, so "able" matches "Copyable". An empty query returns the
 * full registry.
 */
export const searchComponents = (query: string): ComponentCategory[] => {
  const tokens = query.toLowerCase().split(/\s+/).filter(Boolean)
  if (tokens.length === 0) return componentCategories

  return componentCategories
    .map((category) => ({
      ...category,
      components: category.components.filter((item) =>
        tokens.every((token) => item.name.toLowerCase().includes(token)),
      ),
    }))
    .filter((category) => category.components.length > 0)
}
